import React, { useState } from "react";
import styles from "./EventsPage.module.css";

import EventMembersTab from "./EventMembersTab";
import TabBar from "../Shared/TabBar";
import Header from "../Shared/Header";
import { OptionsDropdown } from "../Shared/OptionsDropdown/OptionsDropdown";
import EventList from "./EventList";
import SearchBar from "DreamStream/Shared/SearchBar";
import Card from "../../shared/Card";

import { FaFilter } from "react-icons/fa";
import Button from "shared/Button";
import FilterMenu from "DreamStream/Shared/FilterMenu";
import EventsSnapshotsTab from "./EventsSnapshotsTab";
import ConfirmationModal from "DreamStream/Shared/ConfirmationModal";

export function EventsPage() {
  const [id, setId] = useState(null);

  const [eventName, setEventName] = useState("");
  const titleList = ["Members", "Snapshots"];
  const [activeTitle, setActiveTitle] = useState(titleList[0]);
  const dropOptions = ["Deactivate Group", "Create Temporary"];
  const [filterIsOpen, setFilterIsOpen] = useState(false);

  const [deactivateOpened, setDeactivateOpened] = useState(false);
  const [createOpened, setCreateOpened] = useState(false);

  const groups = [
    { groupName: "Group Status", groupItems: ["Active", "Inactive"] },
  ];

  const handleTabChange = (e) => {
    setActiveTitle(e);
  };

  const events = [
    {
      id: "1",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: false,
    },
    {
      id: "2",
      jobCode: "111",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "3",
      jobCode: "555",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "114",
      jobCode: "654",
      name: "Test event",
      group: "Group Name",
      status: false,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Different Event",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Test Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Different group",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: " Indiviual EventEvent",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: " Spring Leadership",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: false,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: false,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: false,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: false,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
    {
      id: "111",
      jobCode: "123",
      name: "Event Name",
      group: "Group Name",
      status: true,
    },
  ];

  const [sortedEvents, setSortedEvents] = useState(events);

  function onSearch(searchText) {
    let term = searchText.toString().toLowerCase();
    if (term !== "") {
      setSortedEvents(
        events.filter(function (event) {
          return (
            event.jobCode.toString().toLowerCase().includes(term) ||
            event.name.toLowerCase().includes(term) ||
            event.group.toLowerCase().includes(term) ||
            (event.status == true ? "active" : "inactive") == term ||
            (event.status == true ? "true" : "false") == term
          );
        })
      );
    } else {
      setSortedEvents(events);
    }
  }

  const onDetailsClick = (id) => {
    setId(id);
  };

  const onFilterClick = (filters) => {
    alert(filters);
  };

  const optionClicked = (option) => {
    if (option == "Deactivate Group") {
      setDeactivateOpened(true);
    } else if (option == "Create Temporary") {
      setCreateOpened(true);
    }
  };

  return (
    <div>
      <Header title="DIGITAL EVENTS"> </Header>
      {id === null ? (
        <Card className={styles.cardContainer}>
          <div className={styles.header}>DIGITAL EVENTS</div>
          <div className={styles.searchFilter}>
            <SearchBar
              onInput={(searchText) => onSearch(searchText)}
              placeholderText="Search by Event Name or Registered Group Name"
              searchDelay={0}
              minChar={0}
              className={styles["search-bar"]}
              btn={true}
            />
            &nbsp;
            <div className={styles.filterDiv}>
              <Button
                className={styles.filter}
                icon={<FaFilter />}
                onClick={() => {
                  setFilterIsOpen(true);
                }}
                v
              >
                FILTER
              </Button>
            </div>
          </div>

          <EventList
            events={sortedEvents}
            onClick={(id) => onDetailsClick(id)}
          />
        </Card>
      ) : (
        <>
          <div className={styles.header}>
            <Header
              title={eventName.toUpperCase()}
              back={true}
              backTitle={"Back to Events"}
              children={
                <OptionsDropdown
                  placeholder={"OPTIONS"}
                  openedPlaceholder={"SELECT"}
                  options={dropOptions}
                  onChange={(e) => optionClicked(e)}
                />
              }
              onClick={() => setId(null)}
            />
          </div>
          Details contents here
          <div className={styles.tabsContainer}>
            <div className={styles.tabBar}>
              <TabBar
                titleList={titleList}
                activeTitle={activeTitle}
                onChange={handleTabChange}
              />
            </div>
            {activeTitle === "Members" ? (
              id && <EventMembersTab id={parseInt(id)} />
            ) : (
              <EventsSnapshotsTab />
            )}
          </div>
        </>
      )}

      <FilterMenu
        isOpen={filterIsOpen}
        onCollapse={() => setFilterIsOpen(false)}
        onClick={(filters) => alert(filters)}
        groups={groups}
      />
      <ConfirmationModal
        header={"Deactivate Group"}
        isOpen={deactivateOpened}
        onClose={() => setDeactivateOpened(false)}
        onClick={() => alert("onClick called.")}
        description={"Are you sure you would like to deactivate this group?"}
        btnName={"Deactivate"}
      />
      <ConfirmationModal
        header={"Create Temporary Basic Accounts"}
        isOpen={createOpened}
        onClose={() => setCreateOpened(false)}
        onClick={() => alert("onClick called.")}
        description={
          "Are you sure you would like to create temporary accounts for basic members with tickets to events?"
        }
        btnName={"Create"}
      />
    </div>
  );
}
